// extracted by mini-css-extract-plugin
export default {"description":"rVnI","createdAt":"hOw2","creator":"otNz"};